module.exports = __webpack_public_path__ + "img/download-cloud-01.b5434ee0.svg";